import type { InjectionKey } from 'vue';
import { inject } from 'vue';

import type { RequestPlugin } from '../types';

export const PLUGIN_KEY = Symbol('REQUEST_PLUGIN') as InjectionKey<RequestPlugin>;

export function useRequest(): RequestPlugin {
  const plugin = inject<RequestPlugin>(PLUGIN_KEY);

  if (!plugin) {
    throw new Error('Inject Request was called before initialization. Did you forget to install RequestPlugin ?');
  }

  return plugin;
}
